export const transformRecords = (records) => {
    if (records && records.length) {
        return records.map((record) => {
            return {
                id: record.id,
                fullName: record.fullName,
                challenges: record.challenges,
                tags: record.tags,
                photoLocation: `${record.photoLocation.lat}/${record.photoLocation.long}`,
                photoTimestamp: new Date(record.photoTimestamp).toDateString(),
                countryCode: record.countryCode,
            };
        });
    } else {
        return [];
    }
};

export const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
